import L from "leaflet";
import generateGuid from '../../../util/guid';
import { FeatureNames, RouteStyle, ZoneStyle } from './MapConstants';
import { createDirectionDecorator } from './directionDecorator';

export default class FeatureRenderer {
    constructor(map, options = {}) {
        this.map = map;
        this.zoneName = options.bevoorradingMarkerName || FeatureNames.BEVOORRADINGSZONE;
        this.routeGroup = L.layerGroup().addTo(map);
        this.zoneGroup = L.layerGroup().addTo(map);
        this.directionGroup = L.layerGroup().addTo(map);
        this.directionVisible = true;
        map.on('pm:remove', this.onLayerRemoved, this);
    }

    destroy() {
        this.map.off('pm:remove', this.onLayerRemoved, this);
        this.groups().forEach(group => {
            group.clearLayers();
            this.map.removeLayer(group);
        });
    }

    groups() {
        return [this.routeGroup, this.zoneGroup, this.directionGroup];
    }

    onLayerRemoved(e) {
        // geoman verwijdert layers rechtstreeks van de map; hou de groepen synchroon
        this.groups().forEach(group => group.removeLayer(e.layer));
    }

    render(model) {
        this.groups().forEach(group => group.clearLayers());

        if (model) {
            model.routes.forEach(geometry => {
                L.geoJSON({ type: 'Feature', geometry: geometry, properties: {} }, { style: RouteStyle })
                    .getLayers()
                    .forEach(layer => {
                        this.preventRemoval(layer);
                        this.routeGroup.addLayer(layer);
                        this.directionGroup.addLayer(createDirectionDecorator(layer, RouteStyle.color));
                    });
            });

            model.zones.forEach(zone => {
                L.geoJSON(
                    { type: 'Feature', geometry: { type: 'Polygon', coordinates: zone.rings }, properties: { name: this.zoneName } },
                    { style: ZoneStyle })
                    .getLayers()
                    .forEach(layer => this.zoneGroup.addLayer(layer));
            });
        }

        this.applyDirectionVisibility();
    }

    preventRemoval(layer) {
        if (layer.pm)
            layer.pm.setOptions({ allowRemoval: false });
    }

    adoptZone(layer) {
        this.zoneGroup.addLayer(layer);
    }

    setDirectionVisible(visible) {
        this.directionVisible = visible;
        this.applyDirectionVisibility();
    }

    applyDirectionVisibility() {
        if (this.directionVisible && !this.map.hasLayer(this.directionGroup))
            this.map.addLayer(this.directionGroup);
        else if (!this.directionVisible && this.map.hasLayer(this.directionGroup))
            this.map.removeLayer(this.directionGroup);
    }

    hasZones() {
        return this.zoneGroup.getLayers().length > 0;
    }

    getRouteLayers() {
        return this.routeGroup.getLayers();
    }

    eachZone(fn) {
        this.zoneGroup.eachLayer(fn);
    }

    modelFromLayers() {
        const model = { routes: [], zones: [] };

        this.routeGroup.eachLayer(layer => {
            model.routes.push(layer.toGeoJSON().geometry);
        });

        this.zoneGroup.eachLayer(layer => {
            const geometry = layer.toGeoJSON().geometry;
            if (geometry.type === 'Polygon')
                model.zones.push({ id: generateGuid(), rings: geometry.coordinates });
            else if (geometry.type === 'MultiPolygon')
                geometry.coordinates.forEach(rings => model.zones.push({ id: generateGuid(), rings: rings }));
        });

        return model;
    }
}
